import type React from 'react';

import { useEnableExtraAutomationPlaybooks } from '../../../../../feature-flags/hooks/use-enable-extra-automation-playbooks';

import { WeightRuleCard } from './weight-rule-card';
import { InsuranceRuleCard } from './insurance-rule-card';
import { RateShopperRuleCard } from './rate-shopper-rule-card';
import { State48RuleCard } from './state-48-rule-card';
import { AlohaRuleCard } from './aloha-rule-card';
import { ShipFromStoreRuleCard } from './ship-from-store-rule-card';
import { ResidentialRuleCard } from './residential-rule-card';
import { OrderTagRuleCard } from './order-tag-rule-card';
import { CommercialRuleCard } from './commercial-rule-card';

export const PlaybookCards: React.FC = () => {
  const isExtraPlaybooksEnabled = useEnableExtraAutomationPlaybooks();

  return (
    <>
      <WeightRuleCard />
      <InsuranceRuleCard />
      <RateShopperRuleCard />
      {isExtraPlaybooksEnabled && (
        <>
          <State48RuleCard />
          <AlohaRuleCard />
          <ShipFromStoreRuleCard />
          <ResidentialRuleCard />
          <OrderTagRuleCard />
          <CommercialRuleCard />
        </>
      )}
    </>
  );
};
